import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { CardModule } from '@flyfreely-portal-ui/card';
import { EditableModule } from '@flyfreely-portal-ui/editable';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { FeaturesModule } from '@flyfreely-portal-ui/features';
import { AuthorityReportService } from '@flyfreely-portal-ui/flyfreely';
import { ResourceUiModule } from '@flyfreely-portal-ui/resource-ui';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { AttachmentsModule } from 'libs/attachments/src/lib/attachments.module';
import { CurrencyModule } from 'libs/currency/src/lib/currency.module';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { FormatDatePipe, FormatPersonPipe } from 'libs/ui/src/lib/pipes';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxLoadingModule } from 'ngx-loading-reloaded';
import { AssociateAuthoritiesDialogueComponent } from './associate-authority/associate-authority.component';
import { AuthorityDetailsDialogue } from './authority-details/authority-details-dialogue.component';
import { AuthorityDialoguesService } from './authority-dialogues.service';
import { ApplyEndorsements } from './authority-edit/apply-endorsements/apply-endorsements.component';
import { AuthorityEditDialogue } from './authority-edit/authority-edit-dialogue.component';
import { AuthorityGroupAddComponent } from './authority-group-add/authority-group-add.component';
import { AuthorityGroupEdit } from './authority-group-edit/authority-group-edit.component';
import { AuthorityGroupViewComponent } from './authority-group-view/authority-group-view.component';
import { NominatedPersonnelRow } from './nominated-personnel/nominated-personnel-row.component';
import { NominatedPersonnelDialogue } from './nominated-personnel/nominated-personnel.component';
import { AuthorityExpirySummaryComponent } from './registers/authority-expiry-summary/authority-expiry-summary.component';
import { OrganisationAuthorityCheck } from './registers/organisation-authority-check/organisation-authority-check.component';
import { PersonnelRegisterDialogue } from './registers/personnel-register/personnel-register-dialogue.component';
import { RegisterConditions } from './registers/register-conditions/register-conditions.component';
import { RegisterSettings } from './registers/register-settings/register-settings.component';
import { RegisterStatusDisplayComponent } from './registers/register-status-display.component';
import { RpaRegisterDialogue } from './registers/rpa-register/rpa-register-dialogue.component';
import { RegistersSideSheet } from './registers/side-sheet/registers-side-sheet.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BsDatepickerModule,
        PopoverModule,
        TabsModule,
        NgSelectModule,
        SharedUiModule,
        LoadingIndicatorModule,
        TooltipModule,
        ValidationModule,
        AttachmentsModule,
        DragDropModule,
        NgxLoadingModule,
        ButtonsModule,
        CurrencyModule,
        SharedUiModule,
        ResourceUiModule,
        AnalyticsModule,
        EnhancedHelpModule,
        FeaturesModule,
        CardModule,
        EditableModule
    ],
    providers: [
        AuthorityDialoguesService,
        AuthorityReportService,
        FormatDatePipe,
        FormatPersonPipe
    ],
    bootstrap: [],
    declarations: [
        AuthorityEditDialogue,
        AuthorityDetailsDialogue,
        PersonnelRegisterDialogue,
        RpaRegisterDialogue,
        AuthorityGroupEdit,
        NominatedPersonnelDialogue,
        NominatedPersonnelRow,
        OrganisationAuthorityCheck,
        RegisterConditions,
        RegistersSideSheet,
        RegisterSettings,
        AuthorityGroupViewComponent,
        AuthorityGroupAddComponent,
        RegisterStatusDisplayComponent,
        ApplyEndorsements,
        AuthorityExpirySummaryComponent,
        AssociateAuthoritiesDialogueComponent
    ],
    exports: [
        AuthorityGroupEdit,
        AuthorityGroupViewComponent,
        AuthorityGroupAddComponent,
        RegisterStatusDisplayComponent,
        AuthorityExpirySummaryComponent
    ]
})
export class AuthorityModule {}
